/* eslint-disable @typescript-eslint/no-explicit-any */

export interface AuthenticatorsConfig {
  authenticatorId: string;
  identifier: string;
  type: string;
  name: string;
  loginUrl: string;
  getLogoutUrl: string;
  hasLogout: boolean;
  allowPasswordRecovery: boolean;
}

export interface SupportedLanguages {
  code: string;
  name: string;
}

export interface OrganizationConfigs {
  publicId: string;
  privateId: string;
  primaryColor: string;
  logo: string;
  logoWS: string;
  enableScanner: boolean;
  enableOffline: boolean;
  authenticatorsConfig: AuthenticatorsConfig[];
  defaultFileClassId: string;
  defaultFileClassName: string;
  supportedLanguages: SupportedLanguages[];
}
